export const modalBox = {
    aria: {
        closeButtonLabel: 'close modal',
    },
};
//# sourceMappingURL=modal-box.js.map